import { Button, ButtonGroup, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import MOBILE_DEVICE_TYPES from '../../../../constants/mobileDeviceTypes';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

const QR_CODE_URLS = {
  [MOBILE_DEVICE_TYPES.IOS]: {
    url: `${process.env.REACT_APP_API_SERVER}/api/mobile-cards/v1/passes/passkit`,
    type: MOBILE_DEVICE_TYPES.IOS,
  },
  [MOBILE_DEVICE_TYPES.ANDROID]: {
    url: `${process.env.REACT_APP_API_SERVER}/api/mobile-cards/v1/passes/passkit`,
    type: MOBILE_DEVICE_TYPES.ANDROID,
  },
};

const useStyles = makeStyles((theme) => ({
  switchContainer: {
    minWidth: 120,
  },
  textContainer: {
    '& .MuiTypography-root': {
      marginBottom: `${theme.spacing(1)}px !important`,
      display: 'inline-block',
    },
  },
  cardInfo: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
  qrCodeHolder: {
    textAlign: 'center',
    '& .MuiButtonGroup-contained': {
      marginTop: theme.spacing(0.5),
      boxShadow: 'none',
    },
  },
  selectedQrCodeVariant: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  qrCodeVariantBtn: {
    textTransform: 'none',
    minWidth: 94,
  },
}));

const MobileCardInfo = () => {
  const intl = useIntl();
  const classes = useStyles();
  const [qrCodeDeviceType, setQrCodeDeviceType] = useState(QR_CODE_URLS[MOBILE_DEVICE_TYPES.IOS].type);

  const handleChangeUrl = () =>
    setQrCodeDeviceType((prevQrCodeDeviceType) =>
      prevQrCodeDeviceType === MOBILE_DEVICE_TYPES.ANDROID ? MOBILE_DEVICE_TYPES.IOS : MOBILE_DEVICE_TYPES.ANDROID,
    );

  return (
    <Grid container direction="row" justify="space-between" alignItems="flex-start">
      <Grid container item xs={12} md={6} className={classes.textContainer}>
        <Typography variant="h5">{ intl.formatMessage( { id: 'app.mobileCardInfo.title1' }) }</Typography>
        <Typography>
          { intl.formatMessage( { id: 'app.mobileCardInfo.text1' }) }
        </Typography>
        <Typography variant="h5">{ intl.formatMessage( { id: 'app.mobileCardInfo.title2' }) }</Typography>
        <Typography>
          { intl.formatMessage( { id: 'app.mobileCardInfo.text2' }) }
        </Typography>
        <Typography variant="h5">{ intl.formatMessage( { id: 'app.mobileCardInfo.title2' }) }</Typography>
        <Typography>
          { intl.formatMessage( { id: 'app.mobileCardInfo.text3' }) }
        </Typography>
        <Typography variant="h5">{ intl.formatMessage( { id: 'app.mobileCardInfo.title4' }) }</Typography>
        <Typography>
          { intl.formatMessage( { id: 'app.mobileCardInfo.text4' }) }
        </Typography>
        <Typography variant="h5">{ intl.formatMessage( { id: 'app.mobileCardInfo.title5' }) }</Typography>
        <Typography>
          { intl.formatMessage( { id: 'app.mobileCardInfo.text5' }) }
        </Typography>
      </Grid>
      <Grid container item xs={12} md={6} direction="column" justify="center" className={classes.cardInfo}>
        <Typography variant="h5">{ intl.formatMessage( { id: 'app.mobileCardInfo.title6' }) }</Typography>
        <Typography variant="h6">{ intl.formatMessage( { id: 'app.mobileCardInfo.title7' }) }</Typography>
        <Typography component="span">
          <ul>
            <li>
              { intl.formatMessage( { id: 'app.mobileCardInfo.android.hint1' }) } {' '}
              <a href="https://play.google.com/store/apps/details?id=io.walletpasses.android">Google Play</a>
            </li>
            <li>{ intl.formatMessage( { id: 'app.mobileCardInfo.android.hint2' }) }</li>
            <li>{ intl.formatMessage( { id: 'app.mobileCardInfo.android.hint3' }) }</li>
          </ul>
        </Typography>
        <Typography variant="h6">{ intl.formatMessage( { id: 'app.mobileCardInfo.title8' }) }</Typography>
        <Typography component="span">
          <ul>
            <li>{ intl.formatMessage( { id: 'app.mobileCardInfo.ios.hint1' }) }</li>
            <li>{ intl.formatMessage( { id: 'app.mobileCardInfo.ios.hint2' }) }</li>
            <li>{ intl.formatMessage( { id: 'app.mobileCardInfo.ios.hint3' }) }</li>
          </ul>
        </Typography>
        <Grid item container className={classes.qrCodeHolder}>
          <Grid item xs={12}>
            <QRCode value={QR_CODE_URLS[qrCodeDeviceType].url} />
          </Grid>
          <Grid item xs={12}>
            <ButtonGroup variant="contained">
              {Object.values(QR_CODE_URLS).map(({ url, type }) => (
                <Button
                  key={url}
                  className={qrCodeDeviceType === type ? clsx([classes.selectedQrCodeVariant, classes.qrCodeVariantBtn]) : classes.qrCodeVariantBtn}
                  onClick={handleChangeUrl}>
                  {type}
                </Button>
              ))}
            </ButtonGroup>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MobileCardInfo;
